export const DEFAULT_ADSENSE_CLIENT = 'ca-pub-9643138791788383';
const SCRIPT_ID = 'adsense-loader';

export const defaultAdSenseConfig = {
  enabled: true,
  client: DEFAULT_ADSENSE_CLIENT,
  slots: {
    freeSidebar: '',
    freeMobile: '',
    blogFeed: '',
    blogArticle: '',
    blogSidebar: '',
  },
};

export function normalizeAdSenseClient(value) {
  const raw = String(value || '').trim();
  if (/^ca-pub-\d+$/i.test(raw)) return raw;
  if (/^pub-\d+$/i.test(raw)) return `ca-${raw}`;
  return DEFAULT_ADSENSE_CLIENT;
}

export function ensureAdSenseScript(clientId) {
  if (typeof document === 'undefined') return;
  const client = normalizeAdSenseClient(clientId);
  if (!client) return;

  const existing = document.getElementById(SCRIPT_ID)
    || document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]');
  if (existing) return;

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
  document.head.appendChild(script);
}

export function adsensePublisherId(clientId) {
  return normalizeAdSenseClient(clientId).replace(/^ca-/i, '');
}
